import { Chance } from "chance"
import { DictionaryProduct } from "etl/types";

const chance = new Chance();

export const dictionaryProductFactoryMock = (howMany: number): DictionaryProduct[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/api/dictionary_products/${index + 1}`,
		"@type": "DictionaryProduct",
		famille: chance.word(),
		fournisseur: chance.word(),
		hb_brand_id: chance.integer().toString(),
		hb_brand_libelle: chance.word(),
		hb_category_id: chance.integer().toString(),
		hb_category_libelle: chance.word(),
		hb_product_id: chance.integer().toString(),
		hb_product_libelle: chance.word(),
		hb_supplier_id: chance.integer().toString(),
		hb_supplier_libelle: chance.word(),
		id: index + 1,
		libelle: chance.word(),
		marque: chance.word(),
	}));
